import { Modal } from 'src/components/Modal';
import { Button } from 'src/v2/commonComponents/Button';
import styles from './CommonDeleteModal.module.scss';

interface CommonDeleteModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: () => void;
  target?: string;
  title: string;
  customBody?: JSX.Element | string;
  cancelButtonTitle?: string;
  deleteButtonTitle?: string;
}

export const CommonDeleteModal = ({
  isOpen,
  isLoading,
  target,
  customBody,
  cancelButtonTitle,
  deleteButtonTitle,
  title,
  onClose,
  onSubmit,
}: CommonDeleteModalProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className={styles.root}
      overlayClassName={styles.overlay}
    >
      <h5 className={styles.title}>{title}</h5>

      {!customBody ? (
        <p>
          Are you sure you want to delete{' '}
          <span className={styles.chatTitle}>{target}</span>? This action cannot
          be undone.
        </p>
      ) : (
        customBody
      )}

      <div className={styles.buttonsWrapper}>
        <Button color="transparent" onClick={onClose}>
          {cancelButtonTitle || 'Cancel'}
        </Button>
        <Button color="error" onClick={onSubmit} disabled={isLoading}>
          {deleteButtonTitle || 'Delete'}
        </Button>
      </div>
    </Modal>
  );
};
